import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  tabContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));
